angular.module('inhouseNoticeAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-add/inhouse-notice-add.module.js